import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface ISupplierFormMeta {
    distributionMechanism: FormInputMeta;
    rejectTape: FormInputMeta;
    supplierTape1: FormInputMeta;
    supplierTape2: FormInputMeta;
    supplierTape3: FormInputMeta;
    supplierTape4: FormInputMeta;
}

const supplierFormMeta = {} as ISupplierFormMeta;

supplierFormMeta.distributionMechanism = {
    name: "distributionMechanism",
    type: "select",
    label: "Mécanisme de distribution",
    placeholder: "Mécanisme de distribution",
    validation: yup.string().required("Champ obligatoire  !")
};

supplierFormMeta.rejectTape = {
    name: "rejectTape",
    type: "select",
    label: "Cassette de Rejet",
    placeholder: "Cassette de Rejet",
    validation: yup.string().required("Champ obligatoire  !")
};

supplierFormMeta.supplierTape1 = {
    name: "supplierTape1",
    type: "select",
    label: "Cassette 1",
    placeholder: "Cassette 1",
    validation: yup.string().required("Champ obligatoire  !")
};

supplierFormMeta.supplierTape2 = {
    name: "supplierTape2",
    type: "select",
    label: "Cassette 2",
    placeholder: "Cassette 2",
    validation: yup.string().required("Champ obligatoire  !")
};

supplierFormMeta.supplierTape3 = {
    name: "supplierTape3",
    type: "select",
    label: "Cassette 3",
    placeholder: "Cassette 3",
    validation: yup.string().required("Champ obligatoire  !")
};

supplierFormMeta.supplierTape4 = {
    name: "supplierTape4",
    type: "select",
    label: "Cassette 4",
    placeholder: "Cassette 4",
    validation: yup.string().required("Champ obligatoire  !")
};

export default supplierFormMeta;